/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Robotics_TitleInputs */

const en_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Robotics ATP`)
};

const de_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Robotik-Strategie`)
};

const pt_br2_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estratégia Bitwise de Robótica`)
};

const tr_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise Robotik Stratejisi`)
};

const zh_cn2_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 机器人策略`)
};

const zh_hk2_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 機械人策略`)
};

const ko_kr2_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise 로보틱스 전략`)
};

const ru_ru2_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стратегия Bitwise Robotics`)
};

const es_419_strategy_partner_robotics_title = /** @type {(inputs: Strategy_Partner_Robotics_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estrategia Bitwise de Robótica`)
};

/**
* | output |
* | --- |
* | "Bitwise Robotics ATP" |
*
* @param {Strategy_Partner_Robotics_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_robotics_title = /** @type {((inputs?: Strategy_Partner_Robotics_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Robotics_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_robotics_title(inputs)
	if (locale === "de") return de_strategy_partner_robotics_title(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_robotics_title(inputs)
	if (locale === "tr") return tr_strategy_partner_robotics_title(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_robotics_title(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_robotics_title(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_robotics_title(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_robotics_title(inputs)
	return es_419_strategy_partner_robotics_title(inputs)
});